import React, { Component, Fragment, useEffect, useState } from 'react';
import { useHistory, Link } from "react-router-dom"
import logo from '../../logo.svg'
import './style.css';
import { useSelector, useDispatch } from 'react-redux';
import { setLink } from '../../redux/commonReduxSlice';
import toast, { Toaster, ToastBar } from 'react-hot-toast';
import useWindowDimensions from '../../config/useWindowDimensions'
import { SyncOutlined, ArrowLeftOutlined } from '@ant-design/icons';
import { Layout, Form, Input, Button, Checkbox, Row, Col, Radio, Space, Spin, Image } from 'antd';
const { Header, Footer, Sider, Content } = Layout;
const { ReactDraggable: Draggable, ReactDOM } = window;

const layout = {
  wrapperCol: { span: 24, offset: 0 }
};

const tailLayout = {
  wrapperCol: { span: 24, offset: 0 }
};

const tailForgotLayout = {
  wrapperCol: { xs: { span: 24 }, sm: { span: 24, offset: 0 }, md: { span: 24, offset: 0 }, lg: { span: 24, offset: 0 } }
};

const antIcon = <SyncOutlined style={{ fontSize: 24 }} spin />;

const ForgotPassword = () => {

  const dispatch = useDispatch();
  let history = useHistory()
  const [form] = Form.useForm();

  const { height, width } = useWindowDimensions();

  const onFinish = (values) => {

  };

  const onFinishFailed = (errorInfo) => {
    // console.log('Failed:', errorInfo);
  };

  return (
    <Layout className="layout">
      <Content className="content">
        {/* <Spin indicator={antIcon} style={{ textAlign: 'center', width: '100%' }} spinning={isLoading} /> */}
        <div className="auth-pages-bg-light">
          <Row style={{ width: '100%', height: '100%' }}>
            <Col span={9} >
              <div style={{ background: `url('./images/login-bg.png') center center /cover`, width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <Image
                  style={{ zIndex: 1 }}
                  preview={false}
                  // src="./images/logo.png"
                  src="./images/naf-logo.png"
                />
              </div>

            </Col>
            <Col span={15} style={{ paddingBottom: height - (height - 49) }}>
              <div className="login-page-middle-sec">
                {/* <Row className="form-row">
                <Col md={{ span: 14, offset: 6 }} sm={{ span: 12, offset: 6 }} xs={{ span: 12, offset: 6 }}> */}

                <Link to={'/login'} className="backToLoginButton"><Button size="large" style={{}} type="link" icon={<ArrowLeftOutlined />}>Login Page</Button></Link>
                <h1 className="form-row-h1">Forgot Password</h1>
                <h1 style={{ marginBottom: 30, fontSize: 24, fontWeight: 300 }}>Don't worry we are here to help you, Please enter your email id to resent your password</h1>

                <Form
                  className="login-form"
                  {...layout}
                  name="basic"
                  layout="vertical"
                >
                  <Form.Item
                    label="Enter email ID"
                    name="username"
                    rules={[
                      {
                        required: true,
                        message: 'Please enter your email!',
                      },
                    ]}
                  >
                    <Input placeholder={'Enter Email'} allowClear={true} autoComplete="off" className="formInput" />
                  </Form.Item>

                  <Form.Item {...tailLayout} style={{ marginTop: 30 }}>
                    <Button htmlType="submit" type="primary" className="login-btn font-custom-22" block>
                      Submit
                    </Button>
                  </Form.Item>

                  <Form.Item  {...tailForgotLayout} style={{ marginTop: 20, textAlign: 'center' }}>
                  </Form.Item>

                </Form>
                {/* </Col>
              </Row> */}
              </div>
            </Col>
          </Row>
        </div>
      </Content>
    </Layout>

  );
};

export default ForgotPassword;